import React, { useState } from 'react';
import ApartmentFeeNoticePreviewModal from './ApartmentFeeNoticePreviewModal';

interface ViewApartmentFeeNoticeButtonProps {
  apartmentId: string;
  apartmentCode?: string;
  disabled?: boolean;
  className?: string;
}

export const ViewApartmentFeeNoticeButton: React.FC<ViewApartmentFeeNoticeButtonProps> = ({
  apartmentId,
  apartmentCode,
  disabled = false,
  className = 'bg-cyan-600 hover:bg-cyan-700 text-white px-4 py-2 rounded disabled:opacity-50',
}) => {
  const [open, setOpen] = useState(false);
  const [detailed, setDetailed] = useState(false);

  const openPreview = (isDetailed: boolean) => {
    setDetailed(isDetailed);
    setOpen(true);
  };

  return (
    <div className="flex flex-wrap items-center gap-2">
      <button
        type="button"
        disabled={disabled}
        onClick={() => openPreview(false)}
        className={className}
      >
        Xem thông báo phí
      </button>
      <button
        type="button"
        disabled={disabled}
        onClick={() => openPreview(true)}
        className={
          className.includes('bg-cyan-600')
            ? 'bg-cyan-700 hover:bg-cyan-800 text-white px-4 py-2 rounded disabled:opacity-50'
            : className
        }
      >
        Xem thông báo phí chi tiết
      </button>
      <ApartmentFeeNoticePreviewModal
        isOpen={open}
        onClose={() => setOpen(false)}
        apartmentId={apartmentId}
        apartmentCode={apartmentCode}
        detailed={detailed}
      />
    </div>
  );
};

export default ViewApartmentFeeNoticeButton;
